import { SsoQueryField, SsoState } from '@common/neo.tax';

import { env, getFilteredQueryParams, getPathUrl, Path } from '@neo.tax/shared/utils';

import { SsoProvider } from '../firebase';

export const redirectToMicrosoftOAuth = (): void => {
  const existingQueryParams = getFilteredQueryParams();
  existingQueryParams.set(SsoQueryField.SSO_PROVIDER, SsoProvider.MICROSOFT);

  const ssoState: SsoState = {
    existingQueryParams: existingQueryParams.toString(),
    successRedirectUrl: getPathUrl({ path: Path.LOGIN }),
    errorRedirectUrl: getPathUrl({ path: Path.LOGIN }),
  };

  // https://learn.microsoft.com/en-us/graph/auth-v2-user?tabs=http#parameters
  const params = {
    client_id: env.REACT_APP_MICROSOFT_OAUTH_CLIENT_ID,
    redirect_uri: `${env.REACT_APP_BACKEND_BASE_URL}/third-party-tokens/microsoft/callback`,
    response_type: 'code',
    response_mode: 'query',
    scope: 'Files.ReadWrite', // (space-separated list of permission scopes)
    state: JSON.stringify(ssoState),
  };

  const oAuthUrl = new URL('https://login.microsoftonline.com/common/oauth2/v2.0/authorize');
  Object.entries(params).forEach(([key, value]) => oAuthUrl.searchParams.append(key, value));

  // redirect the user to the OAuth URL
  window.location.href = oAuthUrl.toString();
};
